import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {slideFromBotOutside} from '../../../../../animation';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../../services/user-services/user.service';
import {BtnFavoriteComponent} from '../../../../../shared/components/ux/buttons/btn-favorite/btn-favorite.component';
import {
  AccommodationPhotoComponent
} from '../../../../../shared/components/accommodation-specific/accommodation-photo/accommodation-photo.component';
import {DatePipe, DecimalPipe, NgClass, NgIf} from '@angular/common';
import {ItemBadgesComponent} from '../../../../../shared/components/item-badges/item-badges.component';


@Component({
    selector: 'app-accommodation-map-card',
    templateUrl: './accommodation-map-card.component.html',
    styleUrls: ['./accommodation-map-card.component.scss'],
    animations: [
        slideFromBotOutside,
    ],
    standalone: true,
  imports: [NgIf, NgClass, AccommodationPhotoComponent, BtnFavoriteComponent, TranslateModule, DatePipe, ItemBadgesComponent, DecimalPipe]
})
export class AccommodationMapCardComponent implements OnInit {

  @Output() public changedFavorite: EventEmitter<number> = new EventEmitter<number>();
  @Input() public room;
  @Input() public favList = [];
  //
  @Input() public forceUpdate: boolean = false;
  @Output() public closeCard: EventEmitter<number> = new EventEmitter<number>();

  public locale: string;
  public isMobile: boolean = false;

  constructor(
    private _translateService: TranslateService,
    private userService: UserService,
  ) {
  }

  ngOnInit(): void {
    this.locale = this._translateService.currentLang;
    this.isMobile = this.userService.isMobileUser;
  }

  public closeActiveCard(): void {
    this.closeCard.emit(this.room.id);
    this.room = null;
  }

  public changeFavorite(id: number): void {
    this.changedFavorite.emit(id);
  }

}
